import { auth } from "lib/firebase"
import { sendEmailVerification } from 'firebase/auth';
import { paths } from 'routes';
import { API_URL } from 'configuration';

export const VERIFICATION_THROTTLED = 'verification_throttled';

export const sendVerificationEmail = async () => {
  if (!auth?.currentUser) {
    throw new Error('User is not authenticated.');
  }

  try {
    await sendEmailVerification(auth.currentUser, { url: `${API_URL}${paths.auth.login}` });
  } catch (error) {
    if (error.code === 'auth/too-many-requests') {
      const throttled = new Error('A verification email was sent recently. Check your inbox or try again in a few minutes.');
      throttled.code = VERIFICATION_THROTTLED;
      throw throttled;
    }
    throw error;
  }
}

export const sendVerificationEmailIfAllowed = async () => {
  try {
    await sendVerificationEmail();
  } catch (error) {
    if (error.code !== VERIFICATION_THROTTLED) {
      throw error;
    }
  }
}
